import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { AdminShell } from "@/components/admin/admin-shell";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { COMMISSION_RATE } from "@/lib/types";

export const Route = createFileRoute("/settings")({
  component: SettingsPage,
});

function SettingsPage() {
  // Set page title on mount
  useEffect(() => {
    document.title = "Settings — 24Boda Admin";
  }, []);
  return (
    <AdminShell title="Settings" description="Platform configuration">
      <Card className="rounded-lg">
        <CardHeader>
          <CardTitle className="text-base">Platform</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 text-sm">
          <Row label="Currency" value="UGX (Uganda Shillings)" />
          <Row label="Platform commission" value={`${COMMISSION_RATE * 100}%`} />
          <Row label="Rider payout share" value={`${(1 - COMMISSION_RATE) * 100}%`} />
          <Row label="Phone format" value="+256XXXXXXXXX" />
          <p className="pt-2 text-muted-foreground">
            More configuration options will land here soon.
          </p>
        </CardContent>
      </Card>
    </AdminShell>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-center justify-between border-b border-border pb-3 last:border-0">
      <span className="text-muted-foreground">{label}</span>
      <span className="font-medium text-foreground">{value}</span>
    </div>
  );
}
